<template>
  <div
    class="edrea_tm_all_wrap construction_wrap"
    data-magic-cursor="show"
    data-enter="fadeInUp"
    data-exit=""
  >
    <div class="waves"></div>

    <div class="construction_inner">
      <div class="edrea_tm_home">
        <h3 class="name">Data <span class="coloring">Mind</span></h3>
        <h3 class="job">
          Sitio <b>en construcción</b>
        </h3>
        <p class="construction_text">
          Estamos preparando algo increíble. Vuelve pronto.
        </p>

        <div class="progress_bar">
          <span class="progress_fill"></span>
        </div>

        <div class="edrea_tm_button transition_link">
          <a href="mailto:dzome.sv@gmail.com">Contáctanos</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { waves } from "../waves";

export default {
  name: "UnderConstructionView",
  mounted() {
    waves();
  },
};
</script>

<style scoped>
.construction_wrap {
  width: 100%;
  min-height: 100vh;
}

.construction_inner {
  position: relative;
  z-index: 2;
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
}

.construction_inner .edrea_tm_home {
  max-width: 720px;
  margin: 0 auto;
  float: none;
}

.construction_text {
  color: #a2a2a2;
  font-size: 16px;
  margin: -10px 0 40px;
  text-align: center;
}

.progress_bar {
  width: 280px;
  max-width: 80%;
  height: 4px;
  background-color: rgba(255, 255, 255, 0.08);
  border-radius: 50px;
  margin: 0 auto 40px;
  overflow: hidden;
  position: relative;
}

.progress_fill {
  position: absolute;
  top: 0;
  left: -40%;
  width: 40%;
  height: 100%;
  background-color: var(--main-color, #ff5e3a);
  border-radius: 50px;
  animation: construction_loading 2.4s ease-in-out infinite;
}

@keyframes construction_loading {
  0% {
    left: -40%;
  }
  100% {
    left: 100%;
  }
}

@media (max-width: 600px) {
  .construction_inner .edrea_tm_home .name {
    font-size: 48px;
  }
  .construction_inner .edrea_tm_home .job {
    font-size: 20px;
  }
}
</style>
